import { render, staticRenderFns } from "./JxdRefundListDetail.vue?vue&type=template&id=505c8a00&scoped=true"
import script from "./JxdRefundListDetail.vue?vue&type=script&lang=js"
export * from "./JxdRefundListDetail.vue?vue&type=script&lang=js"
import style0 from "./JxdRefundListDetail.vue?vue&type=style&index=0&id=505c8a00&prod&lang=less"
import style1 from "./JxdRefundListDetail.vue?vue&type=style&index=1&id=505c8a00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505c8a00",
  null
  
)

export default component.exports